module.exports = __webpack_public_path__ + "assets/a158db48513df5a09e0efaac87a49361.mp3";